import spFlag from "../../../../img/spFlag.png?width=50px";
import FlagOptionBase from "../../abstracts/flagOptionBase";
import flagItemModal from "./flagItem";

export default class SpFlagOpt extends FlagOptionBase{
    private static titleLegend = "Español";
    private static idOption = "op-sp";
    private static elementToRender = flagItemModal(spFlag,SpFlagOpt.titleLegend);

    constructor(protected modalBody:HTMLElement){
        super(modalBody,SpFlagOpt.idOption,SpFlagOpt.elementToRender);
    }

    translateAction(){
        localStorage.setItem("i18n","sp");
    }
}